import React, { Component } from 'react'
import { connect } from 'react-redux'
import { reduxForm, Field } from 'redux-form'
import { openLoader, closeLoader } from '../../../../../../redux-store/loader'
import { closeModal, openModal } from '../../../../../../redux-store/modal'
import PaymentModel from '../../../../../../data/models/payment/payment'
import I18n from '../../../../../../i18n'
import { Form, Button } from 'semantic-ui-react'
import { required } from '../../../../../../config/validations';
import CustomInput from '../../../../../components/form/input'

class ExtendPremiumLicenses extends Component {
  constructor(props) {
    super(props)

    this.state = {
    }
  }

  handleExtendPremiumLicense = async ({ days }) => {

    const acceptButton = [

      {
        text: I18n.t('actions.accept'),
        callback: () => this.props.closeModal()
      }

    ];

    const titleDays = Math.abs(days);

    const title = days > 0 ? "messages.modal.licenseExtended": "messages.modal.licenseReduced";

    try {

      this.props.openLoader();

      const response = await PaymentModel.extendUserLicense(this.props.userid, { days: parseInt(days) });
      const stripeSync = response.data && response.data.stripeSync;

      // El backend cuenta siempre qué ha pasado en Stripe. Se muestra tal cual: la
      // licencia puede haberse aplicado y el cobro seguir su curso (una cancelación
      // programada, un fallo de Stripe), y el admin tiene que enterarse en vez de
      // dar el cambio por hecho.
      const syncFailed = stripeSync && stripeSync.status === 'failed';
      const syncNotApplied = stripeSync && stripeSync.status === 'skipped';
      const showSyncMessage = stripeSync && (syncFailed || syncNotApplied);

      this.props.openModal({
        headerTitle: syncFailed ? "Aviso" : undefined,
        title: showSyncMessage
          ? (
            <React.Fragment>
              <p>{I18n.t(title, { days: titleDays })}</p>
              <p><strong>Stripe:</strong> {stripeSync.message}</p>
            </React.Fragment>
          )
          : I18n.t(title, { days: titleDays }),
        buttons: acceptButton
      });

      this.props.getUserLicences();

    } catch (error) {

      this.props.closeLoader();
      this.props.openModal({
        headerTitle: "Error",
        title: (error.response && error.response.data && error.response.data.error) || I18n.t('messages.modal.commonError'),
        buttons: acceptButton
      });

    } finally {

      this.props.closeLoader();

    }

  }

  render() {

    return (
      <Form name="licenseForm" onSubmit={this.props.handleSubmit(this.handleExtendPremiumLicense)}>
        <Field
          component={CustomInput}
          placeholder={''}
          name="days"
          inline={true}
          validate={[required]}
          restrictions={[{ numeric: true }]}
        />
        <Form.Field>
          <Button floated="left" content={I18n.t('user.info.extend')} icon='plus' labelPosition='right' size="mini" />
          <div style={{ clear: "both" }}></div>
        </Form.Field>
      </Form>
    )
  }
}


export default reduxForm({
  form: 'licenseForm',
  touchOnBlur: true,
  touchOnChange: false,
  initialValues: {
    days: 0
  }
})(connect(null, { openLoader, closeLoader, closeModal, openModal })(ExtendPremiumLicenses));